import { render, staticRenderFns } from "./ButtonHeader.vue?vue&type=template&id=4e2a301e&scoped=true&"
import script from "./ButtonHeader.vue?vue&type=script&lang=js&"
export * from "./ButtonHeader.vue?vue&type=script&lang=js&"
import style0 from "./ButtonHeader.vue?vue&type=style&index=0&id=4e2a301e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2a301e",
  null
  
)

export default component.exports